(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureUserGroupMapDeleteController',ApplicationFeatureUserGroupMapDeleteController);

    ApplicationFeatureUserGroupMapDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApplicationFeatureUserGroupMap'];

    function ApplicationFeatureUserGroupMapDeleteController($uibModalInstance, entity, ApplicationFeatureUserGroupMap) {
        var vm = this;

        vm.applicationFeatureUserGroupMap = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ApplicationFeatureUserGroupMap.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
